import { useLayoutEffect, useState } from "react";

const createContainer = (): HTMLDivElement => {
    const el = document.createElement("div");
    el.style.cssText =
        "position:fixed;inset:0;pointer-events:none;z-index:9999";
    document.body.appendChild(el);
    return el;
};

/**
 * Creates a fixed-position portal container appended to <body> and removes it
 * on unmount. Returns the element via state so consumers re-render once the
 * container is ready, which is safe under React 18 StrictMode.
 *
 * @public
 */
export const usePortalContainer = (): HTMLDivElement | null => {
    const [container, setContainer] = useState<HTMLDivElement | null>(null);

    useLayoutEffect(() => {
        const el = createContainer();
        setContainer(el);
        return () => {
            document.body.removeChild(el);
            setContainer(null);
        };
    }, []);

    return container;
};
